<template>
  <HeaderComponent />
  <div class="container fixed-heigth">
    <LegacyNoticeComponent />
  </div>
  <FooterComponent />
</template>
<script>
import LegacyNoticeComponent from "../components/LegacyNoticeComponent.vue";
import HeaderComponent from "@/components/HeaderComponent";
import FooterComponent from "@/components/FooterComponent";
export default {
  name: "LegacyNotice",
  components: { LegacyNoticeComponent, HeaderComponent, FooterComponent },
};
</script>
<style lang="scss">
.fixed-heigth {
  min-height: calc(100vh - 250px);
}
</style>
